module.exports = __webpack_public_path__ + "static/media/college-algebra-not-enrolled.dc93ea32.svg";